import React, { useState, useEffect } from "react";
import {
  Button,
  FormFieldSet,
  useFormHandler,
} from "../../../../../../components";

const ProductivityModel = ({ onCancel }) => {
  const [validationRules, setValidationRules] = useState({});
  const initialFormData = {
    clientId: "",
    secretKey: "",
  };
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, validationRules);

  const handleSubmit = () => {
    const isValid = validateAllFields();
  };

  useEffect(() => {
    const baseRules = {
      userName: {
        type: "text",
        required: true,
      },
      secretKey: {
        type: "text",
        required: true,
      },
    };
    setValidationRules(baseRules);
  }, []);

  return (
    <div className="h-120">
      <div className="flex flex-col justify-between border-1 border-gray-200 rounded-lg m-2 p-4">
        <div className="grid grid-cols-2 gap-x-4 gap-y-5">
          <FormFieldSet
            title="Client ID"
            type="text"
            placeholder="Enter"
            value={formData.clientId}
            onChange={(value) => handleChange("clientId", value)}
            error={errors.clientId}
          />
          <FormFieldSet
            title="Secret Key"
            type="text"
            placeholder="Enter"
            value={formData.secretKey}
            onChange={(value) => handleChange("secretKey", value)}
            error={errors.secretKey}
          />
        </div>

        <div className="flex gap-3 self-end pt-4 mt-10 mr-10">
          <Button
            title={"Cancel"}
            variant="outlined"
            onClick={() => onCancel()}
          />
          <Button title={"Save"} onClick={handleSubmit} />
        </div>
      </div>
    </div>
  );
};

export default ProductivityModel;
